import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import PrestadorTipoAgendamentoService from '../../service/PrestadorTipoAgendamentoService';
import AuthorizationService from '../../service/AuthorizationService';

const prestadorTipoAgendamentoService = new PrestadorTipoAgendamentoService(); // Create an instance of PrestadorService

const ListarPrestadorTipoAgendamento = () => {
    const [tipoPrestador, setPrestadorTipoAgendamento] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [tipo, setTipoParaDeletar] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const initPrestadorTipoAgendamento = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await prestadorTipoAgendamentoService.listAllPrestadorTipoAgendamento(iss, null);
            setPrestadorTipoAgendamento(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar servico prestador :", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar servico prestador' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    useEffect(() => {
        initFilters1();
        initPrestadorTipoAgendamento();
    }, [initPrestadorTipoAgendamento]);

    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postPrestadorTipoAgendamento'))
            history.push('/prestador/tipo/agendamento/cadastrar');
    }

    const abreModalDeletar = (tipo) => {
        setTipoParaDeletar(tipo);
        setDeleteDialog(true);
    }

    const handleDeleteTipo = () => {
        if (AuthorizationService.hasPermission('deletePrestadorTipoAgendamento')) {
            setLoading1(true)
            prestadorTipoAgendamentoService.deletePrestadorTipoAgendamento(iss, tipo.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Serviço prestador excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initPrestadorTipoAgendamento();
            });
        }
    }

    const editar = (tipoParaEditar) => {
        if (AuthorizationService.hasPermission('getPrestadorTipoAgendamento'))
            history.push('/prestador/tipo/agendamento/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setTipoParaDeletar(null);
    }

    const ativoBody = (rowData) => {
        // return <span className="p-inputgroup-addon p-inputgroup-addon-checkbox"><Checkbox checked={rowData.ativo} disabled binary /></span>
        // return AuthorizationService.hasPermission('activeUser ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
        return <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} />
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deletePrestadorTipoAgendamento') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getPrestadorTipoAgendamento') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postPrestadorTipoAgendamento') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Serviço Prestador</h5>
                    <DataTable value={tipoPrestador} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma serviço cadastrado.">
                        <Column sortable field="prestador.nome" header="Prestador" filter filterPlaceholder="Procurar por nome" style={{ minWidth: '12rem' }} />
                        <Column sortable field="tipoAgendamento.nome" header="Serviço" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="percentual_servico" header="Percentual" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="status" body={ativoBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir o tipo de prestador selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarPrestadorTipoAgendamento, comparisonFn);
